import { useDispatch, useSelector } from 'react-redux';

import {
  getDownloads,
  setDownloadsAction,
  clearDownloadsAction,
  setDownloadingAction,
  setDownloadingPercentageAction,
} from 'features/downloads/redux/slice';

import { DownloadsItemState, UseDownloadsState } from './types';
import { useTracking } from 'features/tracking';
import { request } from 'app/utils';
import { useSchool } from 'features/school';

const useDownloads = (): UseDownloadsState => {
  const dispatch = useDispatch();
  const downloads = useSelector(getDownloads);

  const { eventTracker } = useTracking();
  const { apiGatewayUrl } = useSchool();

  const setDownloads = (downloads: DownloadsItemState[]) => {
    dispatch(setDownloadsAction(downloads));
  };

  const clearDownloads = () => {
    dispatch(clearDownloadsAction());
  };

  const getDownload = (downloadUrl: string, downloadFileName: string) => {
    dispatch(setDownloadingAction(true));

    eventTracker({ category: 'Conteúdos', action: 'Download', label: `Arquivo: ${downloadFileName}` });

    request<Blob>({
      url: downloadUrl,
      method: 'get',
      baseURL: apiGatewayUrl,
      responseType: 'blob',
      onDownloadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        let percentCompleted = (total===undefined) ? 0 :  Math.floor((loaded / total) * 100);
        dispatch(setDownloadingPercentageAction(percentCompleted));
      },
    })
      .then((response) => {
        saveAs(response.data, downloadFileName);
      })
      .finally(() => {
        dispatch(setDownloadingAction(false));
        dispatch(setDownloadingPercentageAction(0));
      });
  };

  return {
    ...downloads,
    setDownloads,
    clearDownloads,
    getDownload,
  };
};

export default useDownloads;
